var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row page-title"},[_c('div',{staticClass:"col-md-12"},[_c('h4',{staticClass:"mb-1 mt-0"},[_vm._v(_vm._s(_vm.title))])])])}
var staticRenderFns = []

export { render, staticRenderFns }